var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanishMx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_15744)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1108_15744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 18,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1108_15744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9849 9.99999C11.9849 8.92665 11.096 8.05554 10.0007 8.05554C8.90549 8.05554 8.0166 8.92665 8.0166 9.99999C8.0166 11.0733 8.90549 11.9444 10.0007 11.9444C11.096 11.9444 11.9849 11.0733 11.9849 9.99999ZM10.0007 11.1667C10.6579 11.1667 11.1912 10.4705 11.1912 9.6111C11.1912 8.75165 10.6579 8.05554 10.0007 8.05554C9.34359 8.05554 8.81025 8.75165 8.81025 9.6111C8.81025 10.4705 9.34359 11.1667 10.0007 11.1667Z",
    fill: "#406421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 10.3888C10.2195 10.3888 10.3972 10.0406 10.3972 9.61103C10.3972 9.18147 10.2195 8.83325 10.0003 8.83325C9.78118 8.83325 9.60352 9.18147 9.60352 9.61103C9.60352 10.0406 9.78118 10.3888 10.0003 10.3888Z",
    fill: "#D5B852"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 4.16663H7.22255V15.8333H1.66699V4.16663Z",
    fill: "#006946"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7783 4.16663H18.3339V15.8333H12.7783V4.16663Z",
    fill: "#D0091E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 4.55554H3.25395C2.59647 4.55554 2.06348 5.07788 2.06348 5.72221V14.2778C2.06348 14.9221 2.59647 15.4444 3.25395 15.4444H16.746C17.4035 15.4444 17.9365 14.9221 17.9365 14.2778V5.72221C17.9365 5.07788 17.4035 4.55554 16.746 4.55554Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_15744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(1.66699 4.16663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishMx);
export default __webpack_public_path__ + "static/media/Spanish(MX).49e2e976661dad0f3d461a7fb87e308c.svg";
export { ForwardRef as ReactComponent };